import { MantineTheme } from '@mantine/core'

export const getImage = (name: string, theme: MantineTheme, suffix?: string) => {
  return require(`./images/${name}-${theme.colorScheme ?? 'light'}.${suffix ?? 'png'}`)?.default.src
}
